"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cacheClient = void 0;
const interceptors_1 = require("./interceptors");
const memory_cache_1 = require("./memory-cache");
const memory_cache_node_1 = require("./memory-cache-node");
const node_cache_1 = require("./node-cache");
const redis_cache_1 = require("./redis-cache");
const stub_cache_1 = require("./stub-cache");
const isTestEnv = () => process.env.NODE_ENV === 'test';
__exportStar(require("./clientConfig"), exports);
function cacheClient(clientConfg) {
    if (isTestEnv()) {
        return (0, node_cache_1.nodeCache)();
    }
    if (!clientConfg.cacheEnabled) {
        return (0, stub_cache_1.stubCache)();
    }
    switch (clientConfg.cacheType) {
        case 'none':
            return (0, stub_cache_1.stubCache)();
        case 'redis':
            return (0, interceptors_1.withLogging)((0, redis_cache_1.redisCache)(clientConfg));
        case 'node-cache':
            return (0, node_cache_1.nodeCache)();
        case 'memory-cache':
            return (0, memory_cache_1.memoryCache)();
        case 'memory-cache-node':
            return (0, memory_cache_node_1.memoryCacheNode)();
        default:
            throw new Error(`Unknown cache type: ${clientConfg.cacheType}`);
    }
}
exports.cacheClient = cacheClient;
//# sourceMappingURL=index.js.map